import Collaborations from './Collaborations';

function App() {
  return (
    <div>
      <Collaborations />
    </div>
  );
}

export default App;
